export var DELETE_DIRECTION = /*#__PURE__*/function (DELETE_DIRECTION) {
  DELETE_DIRECTION["BACKWARD"] = "backward";
  DELETE_DIRECTION["FORWARD"] = "forward";
  return DELETE_DIRECTION;
}({});
export var LIST_TEXT_SCENARIOS = /*#__PURE__*/function (LIST_TEXT_SCENARIOS) {
  LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
  LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
  LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
  LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
  LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
  LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
  return LIST_TEXT_SCENARIOS;
}({});
export var JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST = /*#__PURE__*/function (JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
  JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
  JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
  JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
  return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
export var OUTDENT_SCENARIOS = /*#__PURE__*/function (OUTDENT_SCENARIOS) {
  OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
  return OUTDENT_SCENARIOS;
}({});